module.exports = __webpack_public_path__ + "static/media/vf-button-sneakers.63b78dce.svg";